<template>
  <vs-button color="danger" type="filled" class="w-full" @click.prevent="restart" v-text="'Reset'"></vs-button>
</template>

<script>
import Cti from '@/models/Cti'
import Log from '@/models/Log'

export default {
  name: 'ResetQueueButton',
  props: {
    server: {
      type: Object,
      required: true
    },
    queue: {
      type: String,
      required: true
    }
  },
  methods: {
    async restart () {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_reset_the_selected_queue'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          await Cti.queueReset(this.server.domain, { queueNo: this.queue })
          await Log.store({
            name: `Reset Queue ${this.queue}`
          })
          this.$swalHelper.success({
            title: this.$t('queue_restarted'),
            text: '',
            confirmButton: this.$t('confirm')
          })
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
